<template>
  <div>
    <p />
    <v-row>
      <v-col md="6" style="margin-top: 25px">
        <v-img src="img/logo-banorte.svg" alt="BANORTE" />
        <input
          :id="userChannel == 'DT' ? 1 : 11"
          v-model="selectedBank"
          type="radio"
          style="margin-top: 10px"
          :value="userChannel == 'DT' ? 1 : 11"
          @change="alertAmount($event)"
        />
      </v-col>
      <v-col md="6">
        <v-img src="img/logo-bbva.svg" alt="BBVA" />
        <input
          :id="userChannel == 'DT' ? 2 : 12"
          v-model="selectedBank"
          type="radio"
          :value="userChannel == 'DT' ? 2 : 12"
          @change="alertAmount($event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6">
        <v-img src="img/logo_santander.png" alt="SANTANDER" />
        <input
          :id="userChannel == 'DT' ? 3 : 13"
          v-model="selectedBank"
          type="radio"
          :value="userChannel == 'DT' ? 3 : 13"
          @change="alertAmount($event)"
        />
      </v-col>
      <v-col md="6" style="margin-top: 15px">
        <v-img src="img/logo_banamex.png" alt="BANAMEX" />
        <input
          :id="userChannel == 'DT' ? 4 : 14"
          v-model="selectedBank"
          :disabled="false"
          type="radio"
          :value="userChannel == 'DT' ? 4 : 14"
          style="margin-top: 10px"
          @change="alertAmount($event)"
        />
      </v-col>
    </v-row>
    <p />
  </div>
</template>

<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  export default {
    name: 'AlertModal',
    props: {
      value: {
        default: 0,
      },
      userChannel: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        selectedBank: this.value,
      };
    },
    watch: {
      value(newVal) {
        this.selectedBank = newVal;
      },
    },
    methods: {
      alertAmount() {
        this.$emit('alertAmountChange', this.selectedBank);
      },
    },
  };
</script>
